import FileUpload from './FileUpload'

export default class FileDrop {
  constructor(opts) {
    this.dropContainer = opts.dropContainer
    this.uploadUrl = opts.uploadUrl
    this.uploadScope = "";
    this.onFileUploadComplete = opts.onFileUploadComplete
    this.onFileUploadError = opts.onFileUploadError
    this.fileInput = opts.fileInput || null
    this.showProgressIndicator = opts.showProgressIndicator || false;
    this.listen()
  }

  listen(){
    $(this.dropContainer)[0].addEventListener('drop', (eve) =>{
      eve.stopPropagation();
      eve.preventDefault();

      $.each(eve.dataTransfer.files, (index, file) => {
        file.uuid = ((Math.random())*0x10000)|0
        this.handleNewFile(file)
      })

      if (this.showProgressIndicator) {
        N2.showProgressIndicator();
      }
    })

    $(this.dropContainer)[0].addEventListener('dragover', (eve) => {
      eve.stopPropagation();
      eve.preventDefault();
      eve.dataTransfer.dropEffect = 'copy';
    });

    if (this.fileInput){
      N2.bindHandler('change', this.fileInput, (eve) =>{
        $.each(eve.target.files, (index, file) => {
          file.uuid = ((Math.random())*0x10000)|0
          this.handleNewFile(file)
        })
      })
    }
  }

  handleNewFile(file) {
    // 200mb cap upload
    if (file.size > 200000000) {
      N2.toast('Your file is too large. Please try again.')
      return false
    }
    self.dispatchEvent(new CustomEvent('Base64 File Upload Started', {'detail': {file: file}}))
    let fileUpload = new FileUpload({
      onComplete: this.onFileUploadComplete,
      onError: this.onFileUploadError,
      uploadUrl: this.uploadUrl,
      uploadScope: this.uploadScope,
    })
    fileUpload.perform(file)
  }

  inituploadScope(scope) {
    this.uploadScope = scope;
  }
}
